<ds-modal [modal]="modal" [title]="'add_users' | translate" [maxWidthPercentage]="80" (modalClosed)="onCancel()">
  <div class="modal-content-wrapper">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <p>{{ 'required_fields_label' | translate }}</p>

      <ds-input
        [label]="'label_security_group_name' | translate"
        [instructions]="availableRoles.length === 1 ? ('option_cant_be_changed' | translate) : ''"
        [state]="availableRoles.length === 1 ? DsInputStates.inactive : DsInputStates.active"
      >
        <select ds-input-field [formControlName]="FormFields.role">
          @for (role of availableRoles; track role.id) {
            <option [value]="role.id">{{ role.name }}</option>
          }
        </select>
      </ds-input>

      <div class="my-4">
        <app-multiselect-typeahead
          [required]="false"
          [verticalLayout]="true"
          [form]="form"
          [formControlName]="FormFields.users"
          [label]="'search_for_existing_user' | translate"
          [selectedLabel]="'users_with_asterisk' | translate"
          [possibleValues]="possibleUsers"
          [fetchPossibleValues]="fetchUsers"
          [valueToDropdownLabelFunction]="valueToDropdownLabel"
          [valueToSelectedItemLabelFunction]="valueToSelectedItemLabel"
        >
        </app-multiselect-typeahead>
      </div>

      @if (validationError()) {
        <div class="error-message" role="alert">
          <ds-icon class="me-1 error-message" [icon]="Icons.CircleExclamation"></ds-icon>
          {{ validationError() }}
        </div>
      }

      <div class="d-flex gap-3 mt-4">
        <button ds-button type="submit" [variant]="DsButtonVariants.primary" (click)="onSubmit()">
          {{ 'add_users' | translate }}
        </button>
        <button ds-button type="button" [variant]="DsButtonVariants.secondary" (click)="onCancel()">
          {{ 'form_cancel' | translate }}
        </button>
      </div>
    </form>
  </div>
</ds-modal>
